/* eslint-disable @typescript-eslint/no-non-null-assertion */
type ImageMap = {
    [key: string]: string;
};

const aiVideoMap: ImageMap = {
    en: "https://wac-cdn-2.atlassian.com/video/upload/f_auto,q_auto/misc-assets/videos/artificial-intelligence/ai-accelerate-work-jsw-generate-table.mp4"
};

const aiImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/ai-img.webp"
};

const staggaredDoubleFeautureFirstImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-1.webp"
};

const staggaredDoubleFeautureSecondImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-staggered-double-feature-2.webp"
};

const heroCardSoftwareDevelopmentImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardSoftwareDev.webp"
};

const heroCardMarketingImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardMarketing.webp"
};

const heroCardItImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardIt.webp"
};

const heroCardDesignImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardDesign.webp"
};

const heroCardOperationsImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/heroCardOps.webp"
};

const collaborateFirstImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-1.webp"
};

const collaborateSecondImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-2.webp"
};

const collaborateThirdImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-3.webp"
};

const collaborateFourthImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-collaborate-4.webp"
};

const doubleFeatureFirstImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-1.webp"
};

const doubleFeatureSecondImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/new-double-feature-2.webp"
};

const productSoftwareDevelopmentModalImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardSoftwareDev.webp"
};

const productMarketingModalImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardMarketing.webp"
};

const productItModalImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardIt.webp"
};

const productDesignModalImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardDesign.webp"
};

const productOperationsModalImageMap: ImageMap = {
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/modalCardOps.webp"
};

export const getProductSoftwareDevelopmentModalImage = (
    locale: string
): string => {
    return (
        productSoftwareDevelopmentModalImageMap[locale] ||
        productSoftwareDevelopmentModalImageMap["en"]!
    );
};

export const getProductMarketingModalImage = (locale: string): string => {
    return (
        productMarketingModalImageMap[locale] ||
        productMarketingModalImageMap["en"]!
    );
};

export const getProductItModalImage = (locale: string): string => {
    return productItModalImageMap[locale] || productItModalImageMap["en"]!;
};

export const getProductDesignModalImage = (locale: string): string => {
    return (
        productDesignModalImageMap[locale] || productDesignModalImageMap["en"]!
    );
};

export const getProductOperationsModalImage = (locale: string): string => {
    return (
        productOperationsModalImageMap[locale] ||
        productOperationsModalImageMap["en"]!
    );
};

export const getDoubleFeatureFirstImage = (locale: string): string => {
    return (
        doubleFeatureFirstImageMap[locale] || doubleFeatureFirstImageMap["en"]!
    );
};

export const getDoubleFeatureSecondImage = (locale: string): string => {
    return (
        doubleFeatureSecondImageMap[locale] ||
        doubleFeatureSecondImageMap["en"]!
    );
};

export const getCollaborateFirstImage = (locale: string): string => {
    return collaborateFirstImageMap[locale] || collaborateFirstImageMap["en"]!;
};

export const getCollaborateSecondImage = (locale: string): string => {
    return (
        collaborateSecondImageMap[locale] || collaborateSecondImageMap["en"]!
    );
};

export const getCollaborateThirdImage = (locale: string): string => {
    return collaborateThirdImageMap[locale] || collaborateThirdImageMap["en"]!;
};

export const getCollaborateFourthImage = (locale: string): string => {
    return (
        collaborateFourthImageMap[locale] || collaborateFourthImageMap["en"]!
    );
};

export const getHeroCardOperationsImage = (locale: string): string => {
    return (
        heroCardOperationsImageMap[locale] || heroCardOperationsImageMap["en"]!
    );
};

export const getHeroCardDesignImage = (locale: string): string => {
    return heroCardDesignImageMap[locale] || heroCardDesignImageMap["en"]!;
};

export const getHeroCardItImage = (locale: string): string => {
    return heroCardItImageMap[locale] || heroCardItImageMap["en"]!;
};

export const getHeroCardMarketingImage = (locale: string): string => {
    return (
        heroCardMarketingImageMap[locale] || heroCardMarketingImageMap["en"]!
    );
};

export const getHeroCardSoftwareDevelopmentImage = (locale: string): string => {
    return (
        heroCardSoftwareDevelopmentImageMap[locale] ||
        heroCardSoftwareDevelopmentImageMap["en"]!
    );
};

export const getStaggaredDoubleFeautureSecondImage = (
    locale: string
): string => {
    return (
        staggaredDoubleFeautureSecondImageMap[locale] ||
        staggaredDoubleFeautureSecondImageMap["en"]!
    );
};

export const getStaggaredDoubleFeautureFirstImage = (
    locale: string
): string => {
    return (
        staggaredDoubleFeautureFirstImageMap[locale] ||
        staggaredDoubleFeautureFirstImageMap["en"]!
    );
};

export const getAiVideo = (locale: string): string => {
    return aiVideoMap[locale] || aiVideoMap["en"]!;
};

export const getAiImage = (locale: string): string => {
    return aiImageMap[locale] || aiImageMap["en"]!;
};
